import { useState } from 'react';
import { Link } from 'react-router-dom';

import { fetchCases } from '../api/client';
import AsyncContent from '../components/AsyncContent';
import CaseCard from '../components/CaseCard';
import CtaBand from '../components/CtaBand';
import FilterChips, { ALL } from '../components/FilterChips';
import PageHero from '../components/PageHero';
import { useApi } from '../hooks/useApi';
import { usePageMeta } from '../hooks/usePageMeta';
import { useLanguage } from '../i18n/LanguageProvider';

export default function CasesPage() {
  const { language, t } = useLanguage();
  const copy = t.cases;

  usePageMeta(copy.metaTitle, copy.metaDescription);

  const cases = useApi(`cases-${language}`, (signal) => fetchCases(language, signal));
  const [filter, setFilter] = useState<string>(ALL);

  return (
    <>
      <PageHero eyebrow={copy.heroEyebrow} title={copy.heroTitle} lead={copy.heroLead} />

      <section className="section">
        <FilterChips
          label={copy.filterLabel}
          options={t.filters.cases}
          active={filter}
          onChange={setFilter}
        />
        <AsyncContent state={cases}>
          {(items) => {
            const visible = filter === ALL ? items : items.filter((item) => item.tags.includes(filter));
            if (visible.length === 0) {
              return <div className="state">{copy.empty}</div>;
            }
            return (
              <div className="case-grid">
                {visible.map((item) => (
                  <CaseCard key={item.id} item={item} />
                ))}
              </div>
            );
          }}
        </AsyncContent>
      </section>

      <section className="section dark">
        <div className="split">
          <div>
            <p className="eyebrow light">{copy.experience.eyebrow}</p>
            <h2>
              {copy.experience.titleTop}
              <br />
              {copy.experience.titleBottom}
            </h2>
          </div>
          <div>
            <p className="large">{copy.experience.large}</p>
            <p>{copy.experience.body}</p>
            <p>
              <Link className="button ghost" to="/kontakt">
                {copy.experience.link}
              </Link>
            </p>
          </div>
        </div>
      </section>

      <CtaBand eyebrow={copy.ctaEyebrow} />
    </>
  );
}
